import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { getAvailableLoyaltyDiscounts } from "../../../../network/calendar";
import { Select, Spin } from "antd";
import { useIntl } from "react-intl";

interface LoyaltyDiscountSelectProps {
  loyaltyDiscount: {
    id: number;
    discount_percentage: string;
  } | null;
  setLoyaltyDiscount: React.Dispatch<
    React.SetStateAction<{
      id: number;
      discount_percentage: string;
    } | null>
  >;
  clientId: number;
  locationId: number;
}
const LoyaltyDiscountSelect: FC<LoyaltyDiscountSelectProps> = ({
  clientId,
  locationId,
  loyaltyDiscount,
  setLoyaltyDiscount,
}) => {
  const intl = useIntl();
  const { data: loyaltyDiscounts, isLoading } = useQuery(
    ["loyaltyDiscounts", clientId, locationId],
    () => getAvailableLoyaltyDiscounts(locationId, clientId),
    {
      enabled: !!clientId && !!locationId,
      select: (res) => res?.data?.data,
    }
  );
  const options = Array.isArray(loyaltyDiscounts)
    ? loyaltyDiscounts?.map((discount) => {
        return {
          value: discount?.id,
          label: (
            <span className="text-[#479821]">
              {Number(
                discount?.loyalty_program_range?.discount_percentage
              )?.toFixed()}
              %-{" "}
            </span>
          ),
        };
      })
    : [];
  if (!!loyaltyDiscounts) {
    if (Array.isArray(loyaltyDiscounts)) {
      if (loyaltyDiscounts?.length === 0 && !!loyaltyDiscount) {
        setLoyaltyDiscount(null);
      }
      if (loyaltyDiscounts?.length === 0) {
        return null;
      }
    }
  }
  return (
    <div>
      {" "}
      <Spin spinning={isLoading} size="small">
        <div className="flex gap-4 justify-between items-center">
          <div>
            <p>{intl.formatMessage({ id: "loyalProgramDiscount" })}</p>
          </div>
          <div>
            <Select
              value={loyaltyDiscount?.id}
              className="min-w-[100px] w-fit"
              options={options}
              onChange={(value) => {
                const discount = loyaltyDiscounts?.find(
                  (discount: { id: number }) => discount?.id === +value
                );
                if (!discount) {
                  setLoyaltyDiscount(null);
                  return false;
                }
                setLoyaltyDiscount(discount as any);
              }}
            />
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default LoyaltyDiscountSelect;
